module.exports = __webpack_public_path__ + "img/story5.97f2f7a4.webp";